import type { Session } from '@acepoker/contract'
import { api } from './api'

export const autoLogin = async (): Promise<{ token: Session['token'] }> => {
  const endpoint = `/api/auth/auto-login`
  return await api().url(endpoint).post({}).json()
}
